module.exports = __webpack_public_path__ + "static/media/ttennis.0f8703e4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/ttennis.svg
// module id = 403
// module chunks = 7